import React, { useState, useEffect } from "react";
import { Col, Card, CardBody, Form, Input, Button } from "reactstrap";
import { Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import CustomModal from "../../components/Modal/modal";
import { useDispatch, useSelector } from "react-redux";
import SDK from "../../config";
import {
  fetchLifeTimeRequest,
  uploadEmailRequest,
  searchLifeTimeRequest,
} from "../../store/LifetimeSubscriber/lifeTimeAction";
import PageSection from '../../components/Loader/loader';

const AllLifeTimeEmails = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [editableRow, setEditableRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ email: "" });
  const [CsvShowModal, setCsvShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const itemsPerPage = 30;
  const [displayedItems, setDisplayedItems] = useState([]);
  const [fetchedEntries, setFetchedEntries] = useState([]);
  const [totalFetchedCount, setTotalFetchedCount] = useState(0);
  const [noResultsFound, setNoResultsFound] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const dispatch = useDispatch();
  const { lifeTimeData, searchResults = [], loading } = useSelector((state) => state.lifeTime);

  useEffect(() => {
    if (!lifeTimeData || lifeTimeData.length === 0) {
      dispatch(fetchLifeTimeRequest(1, 120));
    } else {
      setDisplayedItems(lifeTimeData);
    }
  }, [dispatch, lifeTimeData]);

  useEffect(() => {
    const handleSearch = () => {
      if (searchTerm.length >= 3) {
        setSearchLoading(true);
        dispatch(searchLifeTimeRequest(searchTerm));
      } else {
        setDisplayedItems(lifeTimeData);
        setNoResultsFound(false);
      }
    };

    const timeoutId = setTimeout(handleSearch, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, dispatch, lifeTimeData]);

  useEffect(() => {
    if (currentPage % 4 === 0 && totalFetchedCount <= currentPage * itemsPerPage) {
      const nextPage = currentPage / 4 + 1;
      dispatch(fetchLifeTimeRequest(nextPage, 120));
    }
  }, [currentPage, dispatch, totalFetchedCount]);

  useEffect(() => {
    if (searchTerm.length >= 3) {
      setSearchLoading(false);
      if (searchResults.length > 0) {
        setDisplayedItems(searchResults);
        setNoResultsFound(false);
      }
      else {
        setNoResultsFound(true)
        const timeoutId = setTimeout(() => {
          if (searchResults.length === 0) {
            setDisplayedItems([]);
          }
        }, 500);

        return () => clearTimeout(timeoutId);
      }
    }
    else {
      setDisplayedItems(lifeTimeData);
      setNoResultsFound(false);
    }
  }, [searchResults, searchTerm, lifeTimeData]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const displayedPaginationItems = displayedItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(displayedItems.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    let startPage, endPage;

    if (totalPages <= 3) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 2) {
        startPage = 1;
        endPage = 3;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 2;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
          <Link to="#" className="page-link" onClick={() => paginate(i)}>
            {i}
          </Link>
        </li>
      );
    }

    return pageNumbers;
  };

  const handleAddNewEmail = () => {
    setModalData({ email: "" });
    setShowModal(true);
  };

  const handleUpdate = () => {
    if (modalData.email) {
      dispatch(uploadEmailRequest(modalData.email));
      setDisplayedItems([...displayedItems, { email: modalData.email }]);
      toast.success("Email successfully added!");  
      setShowModal(false);
    } else {
      console.log("Email not provided");
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleCSVUpdate = async () => {
    if (!selectedFile) {
      console.log('File not selected');
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch(SDK.BASE_URL + "/uploadCSV", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        dispatch(fetchLifeTimeRequest(1, 120));
        setCsvShowModal(false);
      } else {
        throw new Error("Failed to upload file.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCsvShowModal(false);
  };

  const handleUploadCsv = () => {
    setCsvShowModal(true);
  };

  return (
    <React.Fragment>
      <Toaster />
      <Col lg={12}>
        <Card style={{ paddingBottom: "55px" }}>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <h4 className="card-title mt-1">Android Beta Emails</h4>
              <Form className="app-search d-none d-lg-block pt-2" onSubmit={(e) => e.preventDefault()}>
                <div className="position-relative d-flex align-items-center">
                  <Input
                    type="text"
                    className="form-control"
                    style={{ width: "50%" }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search"
                  />
                  <span className="ri-search-line"></span>
                  <Button
                    style={{
                      fontSize: "13px",
                      padding: "8px 9px",
                      background: "#636678",
                      border: 'none',
                    }}
                    color="primary"
                    className="ms-2"
                    onClick={handleAddNewEmail}
                  >
                    Add Emails
                  </Button>
                  <Button
                    style={{ fontSize: "13px", padding: "7px 9px" }}
                    color="primary"
                    className="ms-2"
                    onClick={handleUploadCsv}
                  >
                    Upload CSV
                  </Button>
                </div>
              </Form>
            </div>

            {loading || searchLoading ? (
              <div className="table-responsive p-2" style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50%"
              }}>
                <PageSection />
              </div>
            ) :
              (
                <div className="table-responsive">
                  <table className="table table-bordered" style={{ minWidth: "max-content" }}>
                    <thead>
                      <tr>
                        <th className="p-3">No.</th>
                        <th className="p-3">Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedPaginationItems.length === 0 ? (
                        <tr>
                          <td colSpan="12" className="text-center p-5">
                            {noResultsFound ? (
                              <div>No data found</div>
                            ) : (
                              <PageSection />
                            )}
                          </td>
                        </tr>
                      ) : (
                        displayedPaginationItems.map((row, index) => (
                          <tr key={row.id}>
                            <td className="p-3">{index + 1 + indexOfFirstItem}</td>
                            <td className="p-3">{row.email}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  {displayedItems.length > itemsPerPage && (
                    <nav>
                      <ul className="pagination justify-content-end">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <Link to="#" className="page-link" onClick={() => paginate(currentPage - 1)}>&laquo;</Link>
                        </li>
                        {renderPageNumbers()}
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <Link to="#" className="page-link" onClick={() => paginate(currentPage + 1)}>&raquo;</Link>
                        </li>
                      </ul>
                    </nav>
                  )}
                </div>
              )}
          </CardBody>
        </Card>
      </Col>

      {showModal && (
        <CustomModal
          show={showModal}
          handleClose={handleCloseModal}
          modalTitle="Add New Email"
          inputFields={[{
            label: "Email",
            type: "email",
            name: "email",
            placeholder: "Enter Your Email",
            onChange: (e) => setModalData({ email: e.target.value }),
          }]}
          updateButton={{
            variant: "primary",
            text: "Add Email",
            onClick: handleUpdate,
          }}
        />
      )}

      {CsvShowModal && (
        <CustomModal
          show={CsvShowModal}
          handleClose={handleCloseModal}
          modalTitle="Upload CSV"
          inputFields={[{
            label: "Upload CSV",
            type: "file",
            name: "file",
            placeholder: "Choose file",
            onChange: handleFileChange,
            accept: ".csv",
          }]}
          updateButton={{
            variant: "primary",
            text: "Upload",
            onClick: handleCSVUpdate,
          }}
        />
      )}
    </React.Fragment>
  );
};

export default AllLifeTimeEmails;
